
import { Sale } from "@/models/base";
import { SaleService } from "@/services/sale-service";
import { v4 } from "uuid";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	data() {
		return {
			input: "",
			foundSales: [] as Sale[],
			count: 0,
			fetchThread: "",
			fetchedInput: "",
		};
	},
	props: {
		value: {
			type: Object as () => Sale
		},
		fancy: Boolean,
		label: [String, Object as ()=>TranslateResult],
		placeholder: [String, Object as ()=>TranslateResult],
		showRemoveButton: Boolean,
		compactSearch: {
			type: Boolean,
			default: false
		},
	},
	computed: {
		icon():string | undefined{
			if(this.compactSearch) {
				return "search";
			}
			if (this.showRemoveButton) {
				return "times";
			}
			return undefined;
		}
	},
	watch: {
		async input(input: string) {
			if (input.match(/^\s*$/)) {
				this.foundSales = [];
				return;
			}
			let threadId = v4();
			this.fetchThread = threadId;
			try{
				let result = await SaleService.search(input);
				if (this.fetchThread != threadId) return;
				this.foundSales = result.data;
				this.count = result.records;
				this.fetchedInput = input;
				this.fetchThread = "";
			}catch(err){
				if (this.fetchThread == threadId){
					this.fetchThread = "";
				}
			}
		},
		value: {
			immediate: true,
			handler(sale:Sale) {
				if (this.value) {
					this.input = sale.ComputedFriendlyID;
				} else {
					this.input = "";
				}
			}
		}
	},
	methods: {
		trigger(){
			if(this.compactSearch){
				this.$emit("search");
				return;
			}
			this.removeSale();
		},
		async selectSale(sale:Sale) {
			sale = await SaleService.getSale(sale.ID);
			this.$emit("input", sale);
		},
		onBlur() {
			this.foundSales = [];
			if (this.value) {
				this.input = this.value.ComputedFriendlyID;
			}
			this.$emit("blur");
		},
		focus() {
			(this.$refs.input as any).focus();
		},
		blur() {
			(this.$refs.input as any).blur();
		},
		removeSale(){
			this.$emit("input", null);
		},
		async fetchMore(){
			if (this.fetchedInput != this.input) return;

			if (this.foundSales.length >= this.count) return;
			let threadId = v4();
			this.fetchThread = threadId;
			try{
				let result = await SaleService.search(this.fetchedInput, this.foundSales.length, 20);
				if (this.fetchThread != threadId) return;
				this.foundSales.push(...result.data);
				this.fetchThread = "";
			}catch(err){
				if (this.fetchThread == threadId){
					this.fetchThread = "";
				}
			}
		}
	}
});
